import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { doGetSchool } from '../../../store/school.slice';
import { doRemoveAuth } from '../../../store/auth.slice';
import { RootState } from '../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../components/Loader';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Footer from '../../../components/layout/Footer';
import Button from '../../../components/Button';
import { errorVariant, warningVariant } from '../../../lib/barVariant';
import { Descriptions } from 'antd';
import { getCommonCodeLabel } from '../../../lib/store';

interface IMatch {
  id: string;
}

const SystemSchoolRead: FC<RouteComponentProps> = ({ history, location }) => {
  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { school, isLoading } = useSelector((state: RootState) => state.school);

  const match = useRouteMatch<IMatch>();
  const id = String(match.params.id);

  useEffect(() => {
    getSchool(id);
  }, []);

  const getSchool = async (id: string) => {
    const res = await dispatch(doGetSchool(id));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(
          res?.data?.data || t('common.message.error'),
          errorVariant,
        );
    }
  };

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.school.title3')}
      />
      <div className="comm-table__area rowType edit">
        <Descriptions
          bordered
          size="small"
          column={1}
          labelStyle={{ width: '20%' }}
        >
          <Descriptions.Item label={t('system.school.column1')}>
            {school?.schoolCode}
          </Descriptions.Item>
          <Descriptions.Item label={t('system.school.column2')}>
            {school?.schoolName}
          </Descriptions.Item>
          <Descriptions.Item label={t('system.school.column3')}>
            {getCommonCodeLabel('SY0013', school?.schoolDiv || '', i18n.language)}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.text.address1')}>
            ({school?.zipNo}) {school?.address}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.text.address2')}>
            {school?.detailAddress}
          </Descriptions.Item>
          <Descriptions.Item label={t('system.school.tel')}>
            {school?.telephoneNo}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.text.fax')}>
            {school?.faxNo}
          </Descriptions.Item>
          <Descriptions.Item label={t('system.school.homepage')}>
            {school?.homepageAddress}
          </Descriptions.Item>
          <Descriptions.Item label={t('common.text.note')}>
            {school?.note || ''}
          </Descriptions.Item>
        </Descriptions>        

        <div className="comm-bx__space">
          <div className="comm-btn__area justify-content-center">
            <Button
              className="btn-basic gray-line"
              onClick={() => 
                history.goBack()
                }
              text={t('common.button.list')}
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SystemSchoolRead;
